import { render, staticRenderFns } from "./FirmGroupFirms.vue?vue&type=template&id=5d27545b"
import script from "./FirmGroupFirms.vue?vue&type=script&lang=js"
export * from "./FirmGroupFirms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports